/**
 * 폼 입력 컨트롤(input/textarea/select) 공통 className 빌더.
 *
 * 컴포넌트 파일(FieldShell)에서 분리: react-refresh 규칙상 컴포넌트 파일은
 * 컴포넌트만 export 해야 Fast Refresh 가 동작한다. 스타일 유틸은 여기로.
 */
/**
 * 배경·글자색을 다크에서도 직접 준다. 투명 배경에 글자색만 물려받으면 select 의
 * 펼친 목록이 브라우저 기본(흰 배경)으로 떠서 밝은 글자가 묻힌다(자료실 분류 등).
 * scheme-dark 는 펼친 목록·스크롤바를 어둡게 그리게 한다.
 */
const inputBase = [
  'block w-full rounded-lg border px-3 py-2.5 text-sm outline-none transition-colors',
  'bg-white text-neutral-950 dark:bg-dark-base dark:text-neutral-100 dark:scheme-dark',
  'placeholder:text-neutral-400',
].join(' ');

export const inputClass = (error?: string): string =>
  [
    inputBase,
    error
      ? 'border-red-400 focus:border-red-500'
      : 'border-black/15 focus:border-neutral-950 dark:border-white/15 dark:focus:border-white/50',
  ].join(' ');
